const ArticleBlockTextSetup = () => {
  const components = document.querySelectorAll('[data-component-article-block-text]');

  components.forEach((component) => {
    const links = component.querySelector('.primary').querySelectorAll('a');

   /* links.forEach((link) => {
      const text = link.innerHTML;
      link.innerHTML = `<span class="label">${text}</span><span class="icon-link-arrow"></span>`;
    });
    */
  });
};
ArticleBlockTextSetup();